import { lazy } from 'react';

export const SearchAsync = lazy(() => import('./search.component'));
